//libs
// import "babel-polyfill";
import svg4everybody from "svg4everybody";
svg4everybody();

//partials
import "./partials/detectMobile";
import "./partials/toggleNav";
import "./partials/toggleSearch";
import "./partials/toggleChannelNav";
import "./partials/toggleAllChannels";
import "./partials/lazyload";
import "./partials/inputPlaceholder";
import "./partials/stickyShareBar";
import "./partials/channelOverview";
import "./partials/MoverDetail";
import "./partials/pageShare";
import "./partials/subscribeActions";
import "./partials/subscribeFAQ";
import "./partials/loadTopstories";
import "./partials/smoothScroll";
import "./partials/countViews";
import "./partials/SubscribeToComments";
import "./partials/stickyAside";
import "./partials/widgetExpand";
import "./partials/periodicRefresh";
import "./partials/knowledgebaseDownloadHandling";
import "./partials/initVideos";
import "./partials/initSliders";
